//
// Copyright (c) 2025 Emplifi, Inc.
//

import type {
  ModelElement,
  ModelDocumentSelection,
  ViewDocumentSelection,
  ViewElement,
} from "ckeditor5";

export function getSnippetWidgetDocument(selection: ModelDocumentSelection): ModelElement | null {
  const selectionPosition = selection.getFirstPosition();
  if (!selectionPosition) {
    return null;
  }
  const selectedElement = selection.getSelectedElement();
  if (selectedElement && selectedElement.name == "snippet") {
    return selectedElement;
  }
  return selectionPosition.findAncestor("snippet");
}

export function getSnippetWidgetView(selection: ViewDocumentSelection): ViewElement | null {
  const selectionPosition = selection.getFirstPosition();
  if (!selectionPosition) {
    return null;
  }
  const selectedElement = selection.getSelectedElement();
  if (
    selectedElement &&
    selectedElement.name == "div" &&
    selectedElement.hasAttribute("data-snippet-id")
  ) {
    return selectedElement;
  }
  return null;
}
